import {
  getControlPlaneAccessToken,
  getDesktopSidecarAccessToken,
  getOpenAnalystAccountAccessToken,
  getOpenAnalystAccessToken,
  refreshControlPlaneAccessToken,
  refreshOpenAnalystAccessToken,
} from "./token"
import { localDevAuthBypass } from "./dev-bypass"
import { createAuthFetch, type AuthFetch } from "./fetch"

export type AppBrokerCredentialErrorCode =
  | "missing_openanalyst_session"
  | "missing_control_plane_session"
  | "missing_desktop_sidecar_session"

export class AppBrokerCredentialError extends Error {
  readonly code: AppBrokerCredentialErrorCode

  constructor(code: AppBrokerCredentialErrorCode) {
    super(code)
    this.name = "AppBrokerCredentialError"
    this.code = code
  }
}

export function isMissingOpenAnalystSessionError(error: unknown) {
  return error instanceof AppBrokerCredentialError && error.code === "missing_openanalyst_session"
}

export function getOpenAnalystApiAccessToken() {
  return getOpenAnalystAccessToken()
}

export async function requireOpenAnalystApiAccessToken() {
  const token = getOpenAnalystAccessToken() ?? (localDevAuthBypass() ? null : await refreshOpenAnalystAccessToken())
  if (token) return token
  throw new AppBrokerCredentialError("missing_openanalyst_session")
}

export function getControlPlaneAccessTokenForRoute() {
  return getControlPlaneAccessToken()
}

export async function requireControlPlaneAccessTokenForRoute() {
  const token = getControlPlaneAccessToken() ?? (localDevAuthBypass() ? null : await refreshControlPlaneAccessToken())
  if (token) return token
  throw new AppBrokerCredentialError("missing_control_plane_session")
}

export function getDesktopSidecarAccessTokenForRoute() {
  return getDesktopSidecarAccessToken()
}

export function getOpenAnalystAccountAccessTokenForRoute() {
  return getOpenAnalystAccountAccessToken()
}

export function getForwardedOpenAnalystProviderToken() {
  return getOpenAnalystAccessToken()
}

export function createControlPlaneAuthFetch(fetchImpl: AuthFetch) {
  return createAuthFetch({
    fetchImpl,
    getAccessToken: getControlPlaneAccessTokenForRoute,
    refreshAccessToken: refreshControlPlaneAccessToken,
  })
}

export const appBrokerAuthFetch = {
  getOpenAnalystApiAccessToken,
  refreshOpenAnalystApiAccessToken: refreshOpenAnalystAccessToken,
  getDesktopSidecarAccessTokenForRoute,
  refreshControlPlaneAccessTokenForRoute: refreshControlPlaneAccessToken,
}
